/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input, OnDestroy} from "@angular/core";

import {createBufferedFlag, readBufferedFlag} from "../../util/template-state";

@Component({
  standalone: false,
  selector: 'message-dismisser',
  template: `<div *ngIf="visible" class="alert alert-success clickable" (click)="dismiss()" title="Click to dismiss message">{{message}}<span class="fa fa-times pull-right"></span></div>`
})
export class MessageDismisserComponent implements OnDestroy {
  @Input() result: any;
  @Input() messageType: string;

  private readonly visibleFlag = createBufferedFlag(false);
  private destroyed = false;

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  /**
   * result.data can flip true in a save then() during an existing CD turn
   * (modal close). Keep *ngIf stale until the next macrotask (NG0100).
   */
  get visible(): boolean {
    return readBufferedFlag(this.visibleFlag, !!this.result?.data, this.cdr, () => !this.destroyed);
  }

  get message(): string {
    if (this.messageType === 'creative') {
      return "Your creative updates were saved successfully";
    }
    if (this.messageType === 'productLayouts') {
      return "Your layout selections were updated successfully";
    }
    if (this.messageType === 'orderBudgets') {
      return "Your budget updates were saved successfully";
    }
    return "Your targeting updates were saved successfully";
  }

  dismiss(): void {
    if (this.result) {
      this.result.data = false;
    }
    this.visibleFlag.display = false;
    this.visibleFlag.last = false;
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
